export const ID = '850b43a8-06f2-46fb-a84b-b1a04a1a1303';

export const NAME = 'Text Header';
